"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentType = void 0;
var PaymentType;
(function (PaymentType) {
    PaymentType[PaymentType["Mastercard"] = 1] = "Mastercard";
    PaymentType[PaymentType["Invoice"] = 2] = "Invoice";
    PaymentType[PaymentType["Reservation"] = 3] = "Reservation";
    PaymentType[PaymentType["Organizer"] = 4] = "Organizer";
    PaymentType[PaymentType["Free"] = 5] = "Free";
    PaymentType[PaymentType["POS"] = 6] = "POS";
    PaymentType[PaymentType["Visa"] = 7] = "Visa";
    PaymentType[PaymentType["Amex"] = 8] = "Amex";
    PaymentType[PaymentType["Postfinance"] = 9] = "Postfinance";
    PaymentType[PaymentType["Paypal"] = 10] = "Paypal";
    PaymentType[PaymentType["Sofort"] = 11] = "Sofort";
    PaymentType[PaymentType["SepaDirectDebit"] = 12] = "SepaDirectDebit";
    PaymentType[PaymentType["CreditcardOnsite"] = 13] = "CreditcardOnsite";
    PaymentType[PaymentType["Twint"] = 14] = "Twint";
    PaymentType[PaymentType["ExternalPayment"] = 15] = "ExternalPayment";
    PaymentType[PaymentType["GooglePay"] = 16] = "GooglePay";
    PaymentType[PaymentType["ApplePay"] = 17] = "ApplePay";
})(PaymentType = exports.PaymentType || (exports.PaymentType = {}));
